import React from "react";
import { Component } from "react";
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import axios from 'axios';
import Select from 'react-select';
import Modal from 'react-modal';

class Register extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            gender: "",
            fullname: "",
            emailaddress: "",
            mobilePhone: "",
            address: "",
            country: "",
            selectedServiceArea: "",
            selectedCity: "",
            selectedCountry: "",
            selectedGender: "",
            area: "",
            city: "",
            password: "",
            allCustomerRegistrations: [],
            countryCities: [],
            organisations: [],
        }
    }

    orgs = [];
    genders = [
        { label: "Female", value: "Female" },
        { label: "Male", value: "Male" },
        { label: "Other", value: "Other" }
    ]

    /* countries = [
         { label: "Angola", value: "Angola" },
         { label: "Cote d'Ivoire", value: "Cote d'Ivoire" },
         { label: "Congo Democratic", value: "Congo Democratic" },
         { label: "Congo Republic", value: "Congo Republic" },
         { label: "Ghana", value: "Ghana" },
         { label: "South Africa", value: "South Africa" },
         { label: "Zimbabwe", value: "Zimbawe" },
     ]
 
     countriesCities = [
         { label: "Angola", value: "Luanda" },
         { label: "Angola", value: "Cubango" },
         { label: "Cote d'Ivoire", value: "Abidjan" },
         { label: "Congo Democratic", value: "Kinshasa" },
         { label: "Congo Democratic", value: "Lubumbashi" },
         { label: "Congo Democratic", value: "Mbuji Mayi" },
         { label: "Congo Republic", value: "Brazzaville" },
         { label: "Congo Republic", value: "Pointe Noire" },
         { label: "Congo Republic", value: "Dolisie" },
         { label: "Congo Republic", value: "Nkayi" },
         { label: "Congo Republic", value: "Ouesso" },
         { label: "Ghana", value: "Accra" },
         { label: "South Africa", value: "Johannesburg" },
         { label: "South Africa", value: "Cape Town" },
         { label: "South Africa", value: "Tswane" },
         { label: "South Africa", value: "Limpopo" },
         { label: "South Africa", value: "East London" },
         { label: "South Africa", value: "Durban" },
         { label: "South Africa", value: "Port Elizabeth" },
         { label: "Zimbabwe", value: "Bulawayo" },
         { label: "Zimbabwe", value: "Harare" }
     ] */

    countries = [
        { label: "South Africa", value: "South Africa" },

    ]
    countriesCities = [
        { label: "South Africa", value: "Cape Town" },
    ]

    setAreaChange = (e) => {

        this.setState({ area: e, selectedServiceArea: e.value });
    }

    serviceAreas = [
        { label: "Blouberg", value: "Blouberg" },
        { label: "Maitland", value: "Maitland" },
        { label: "Milnerton", value: "Milnerton" },
        { label: "Parklands", value: "Parklands" },
        { label: "Sunningdale", value: "Sunningdale" },
        { label: "Other", value: "Other" }
    ]

    handleRegisterClose = () => {
        this.setState({
            open: false, fullname: "", emailaddress: "", mobilePhone: "",
            gender: "", username: "", password: "", country: "", city: "", register: "", address: ""
        });
        document.getElementById('successRegstration').style.display = "none";
        document.getElementById('failRegstration').style.display = "none";
        this.props.onRegisterClose();
        // this.props.loadProduct();
    };

    getAllCustomerRegistrations = async () => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "db": "iwash_laundry" }
        }
        //  const url = "http://localhost/iwash-php/api/allCustomerRegistrations.php";
       const url = "https://testmembership.bktsystems.com/api/UAT_allCustomerRegistrations.php";
       // const url = "https://testmembership.bktsystems.com/api/allCustomerRegistrations.php";
        const response = await axios.get(url, config);
        this.setState({ allCustomerRegistrations: response.data });
    }

    componentDidMount = async () => {
        this.getAllCustomerRegistrations();
        if (this.props.emailaddress !== undefined || this.props.mobilePhone !== undefined || this.props.fullname !== undefined || this.props.area !== undefined) {
            this.setState({ fullname: this.props.fullname, emailaddress: this.props.emailaddress, mobilePhone: this.props.mobilePhone, area: this.props.area });

        }
        //    console.log('>>>>>' + this.props.area+'<<<<<<<<'+this.props.emailaddress);
        //this.getAllOrgs();

    }
    titleCase = (str) => {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    getCountryCities = (country) => {

        let countryCity = [];
        {
            this.countriesCities.map(item => {
                var obj = {};
                if (item.label === country) {
                    obj["label"] = item.value;
                    obj["value"] = item.value;
                    countryCity.push(obj)
                }
            })
        }
        this.setState({ countryCities: countryCity });
    }

    setUserName = (e) => {
        this.setState({
            emailaddress: e.target.value
        });
    };

    setPassword = (e) => {
        this.setState({
            password: e.target.value
        });
    };

    handleRegisterOpen = () => {
        this.setState({ open: true });
    };

    setGenderChange = (e) => {
        this.setState({ gender: e, selectedGender: e.value });
    }

    setFullName = (e) => {
        this.setState({ fullname: this.titleCase(e.target.value) });
        //console.log(this.titleCase(e.target.value))
    }

    setAddress = (e) => {
        this.setState({ address: this.titleCase(e.target.value) });
    }

    setPhoneNumber = (e) => {
        this.setState({ mobilePhone: e.target.value });
    }

    setCountry = (e) => {
        this.setState({ country: e, selectedCountry: e.value });
        this.getCountryCities(e);
    }
    setCity = (e) => {
        this.setState({ city: e, selectedCity: e.value });
    }

    handleAddressChange = (e) => {
        this.setState({
            address: e.target.value
        });
    }
    saveRegistration = async (e) => {
        e.preventDefault();
        let surveyor = this.props.fullname === undefined ? "no" : "yes";

        let config = {
            headers: { 'Accept': 'application/json' },
            params: {
                "db": "iwash_laundry", gender: this.state.gender, fullname: this.props.fullname !== undefined ? this.props.fullname : this.state.fullname,
                emailaddress: this.props.emailaddress !== undefined ? this.props.emailaddress : this.state.emailaddress,
                mobilePhone: this.props.mobilePhone !== undefined ? this.props.mobilePhone : this.state.mobilePhone, address: this.state.address, country: this.state.country,
                city: this.state.city, area: this.props.area !== undefined ? this.props.area : this.state.area, password: this.state.password
            }
        }

        // console.log(config.params);

        if (this.state.allCustomerRegistrations.length > 0) {
            var emailExists = this.state.allCustomerRegistrations.some(item => item.emailaddress === this.state.emailaddress);
            if (emailExists) {
                document.getElementById("btnSubmit").style.display = "none";
                document.getElementById('userExists').style.display = "block";
                document.getElementById('successRegstration').style.display = "none";
                document.getElementById('failRegstration').style.display = "none";
                return;
            }
        }

        if ((surveyor === "no") && (this.state.fullname === "" || this.state.emailaddress === "" || this.state.mobilePhone === "" || this.state.address === ""
            || this.state.country === "" || this.state.city === "" || this.state.area === "" || this.state.password === "")) {
            alert("Please fill in all the fields to complete your registration");
            return;
        }
        else if ((surveyor === "yes") && (this.state.address === "" || this.state.country === "" || this.state.city === "" || this.state.password === "")) {
            alert("Please fill in the remaining fields to complete your registration");
            return;
        }

        else {
            //   console.log(config.params);
            // const url = "http://localhost/iwash-php/api/saveCustomer.php";
            const url = "https://testmembership.bktsystems.com/api/UAT_saveCustomer.php";
            //const url = "https://testmembership.bktsystems.com/api/saveCustomer.php";
            const response = await axios.get(url, config);

            if (response.data.includes("Success")) {
                document.getElementById("btnSubmit").style.display = "none";
                document.getElementById('successRegstration').style.display = "block";
                document.getElementById('failRegstration').style.display = "none";
                this.setState({
                    gender: "", selectedGender: "", fullname: "", emailaddress: "", mobilePhone: "", address: "", country: "",
                    city: "", area: "", password: "", selectedCity: "", selectedCountry: "", selectedServiceArea: ""
                });
            }
            else {
                document.getElementById('successRegstration').style.display = "none";
                document.getElementById('failRegstration').style.display = "block";
            }
            this.getAllCustomerRegistrations();
            //  console.log(response.data);
        }
    }
    customStyles = {
        control: (provided) => ({
            ...provided,
            height: '50px',
            borderBottom: "2px solid darkblue"
        })
    }

    render() {

        return (
            <>
                <Modal ariaHideApp={false} isOpen={this.state.open} onClose={this.handleRegisterClose}>
                    <Form >
                        <div className="mainDivHome" style={{
                            border: '1px solid rgb(89, 100, 95)', borderRadius: "10px", fontFamily: "lora",
                            margin: "5", padding: "0", paddingLeft: "10px", paddingRight: "10px", color:"darkblue", fontSize:"18px"
                        }}>
                            <div style={{ textAlign: "center", paddingTop: "5px", textShadow: "1px 1px 2px white", color: "darkblue" }}><h6>REGISTER</h6></div>                                                                <FormGroup>
                                <Label for='gender' style={{ color: "darkblue", fontStyle: "italic" }}>Gender</Label>
                                <Select
                                styles = {this.customStyles}
                                    options={this.genders}
                                    maxMenuHeight="100%"
                                    // defaultInputValue=""
                                    value={this.state.selectedGender}
                                    onChange={opt => this.setGenderChange(opt.label)}
                                ></Select>
                            </FormGroup>
                            <FormGroup>
                                <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    type='text'
                                    id='fullName'
                                    name='fullName'
                                    required={true}
                                    placeholder="Your full name"
                                    value={this.props.fullname !== "undefined" ? this.props.fullname : this.state.fullname}
                                    onChange={this.setFullName}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    type='number'
                                    id='phonenumber'
                                    name='phonenumber'
                                    required={true}
                                    placeholder="Your phone number"
                                    value={this.props.mobilePhone !== "undefined" ? this.props.mobilePhone : this.state.mobilePhone}
                                    onChange={this.setPhoneNumber}
                                    min={10}
                                    max={10}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    id="userName"
                                    name="userName"
                                    required={true}
                                    placeholder="Your e-mail address"
                                    value={this.props.emailaddress !== "undefined" ? this.props.emailaddress : this.state.emailaddress}
                                    onChange={this.setUserName}
                                    type="email"
                                />
                            </FormGroup>
                            <FormGroup>
                                <Input
                                style={{ height: '50px', borderBottom: "2px solid darkblue" }}
                                    id="password"
                                    name="password"
                                    required={true}
                                    placeholder="Set your password"
                                    onChange={this.setPassword}
                                    type="password"
                                    value={this.state.password}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for='country' style={{ color: "darkblue", fontStyle: "italic" }}>Country</Label>
                                <Select
                                styles={this.customStyles}
                                    options={this.countries}
                                    maxMenuHeight="100%"
                                    defaultInputValue=""
                                    onChange={opt => this.setCountry(opt.label)}
                                    value={this.state.selectedCountry}
                                ></Select>
                            </FormGroup>
                            <FormGroup>
                                <Label for='city' style={{ color: "darkblue", fontStyle: "italic" }}>City</Label>
                                <Select
                                styles={this.customStyles}
                                    options={this.state.countryCities}
                                    maxMenuHeight="100%"
                                    defaultInputValue=""
                                    onChange={opt => this.setCity(opt.label)}
                                    value={this.state.selectedCity}
                                ></Select>
                            </FormGroup>
                            <FormGroup>
                                <Label for='serviceareas' style={{ color: "darkblue", fontStyle: "italic" }}>Area</Label>
                                <Select
                                styles={this.customStyles}
                                    options={this.serviceAreas}
                                    maxMenuHeight="100%"
                                    defaultInputValue={this.props.area !== undefined ? this.props.area : this.state.selectedServiceArea}
                                    onChange={opt => this.setAreaChange(opt.label)}
                                // styles={this.customStyles}
                                ></Select>
                            </FormGroup>
                            <FormGroup>
                                <Label for="address" style={{ color: "darkblue", fontStyle: "italic" }} >Your address (for pick-up & delivery purposes)</Label>
                                <Input
                                style={{borderBottom: "2px solid darkblue" }}
                                    type="textarea"
                                    id="address"
                                    name="address"
                                    required={true}
                                    rows="2"
                                    value={this.state.address}
                                    onChange={this.handleAddressChange}
                                />
                            </FormGroup>
                            <div id='successRegstration' style={{ textAlign: "center", color: "green", display: "none" }}><Label> <h4>You have successfully registered, thank you! &#128591;
                                You may now log in to your account. </h4></Label>
                            </div>
                            <div id='userExists' style={{ textAlign: "center", color: "orange", display: "none" }}><Label> <h4>You are already registered! Please log in or reset your password to log in.</h4></Label></div>
                            <div id='failRegstration' style={{ textAlign: "center", color: "red", display: "none" }}><Label> <h4>There was an error signing up, please try again &#128533;</h4></Label></div>
                            <div id='btnSubmit' style={{ paddingTop: "20px" }}>
                                <Button style={{ backgroundColor: "rgb(9, 59, 16)", width: "100%", fontWeight: "bold", color: "white" }} type="submit" onClick={this.saveRegistration}>Submit</Button>
                            </div>
                            <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                                <Button style={{ width: "100%", fontWeight: "bold" }}
                                    onClick={this.handleRegisterClose} color="danger">
                                    Close
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Modal>
            </>
        );
    }
}
export default Register